import { ArticleCard } from './ArticleCard';
import { Carousel } from './Carousel';
import { FeaturedArticlesFragment } from './FeaturedArticles.generated';
import { Column, Row, Section } from './Section';
import { Text } from './Text';

interface FeaturedArticlesProps {
  snippetGroup?: FeaturedArticlesFragment;
  background?: 'BLUE' | 'WHITE';
}

export const FeaturedArticles: React.FC<FeaturedArticlesProps> = ({
  snippetGroup,
  background = 'WHITE',
}) => {
  if (!snippetGroup) {
    throw new Error('FeaturedArticles snippetGroup not defined');
  }

  return (
    <Section background={background}>
      <Row>
        <Column>
          <Text.H2 className="text-center !mb-2">{snippetGroup.name}</Text.H2>
          <Text.Body className="text-center !text-gray-500 !text-2xl !font-medium">
            {snippetGroup.subtitle}
          </Text.Body>
        </Column>
      </Row>
      <Carousel className="!gap-5 pb-3" group background="WHITE">
        {snippetGroup.snippetsCollection?.items
          .flatMap((item) => (item?.__typename === 'Article' ? item : []))
          .map((article) => (
            <ArticleCard article={article} key={article.sys.id} />
          ))}
      </Carousel>
    </Section>
  );
};
